import React from 'react';
import cn from 'classnames';

import styles from './index.module.scss';

type Props = {
    size?: string,
};

const defaultProps = {
    size: 'large',
};

export const Loader:React.FC<Props> = ({ size }) => {
    const loaderClass = cn({
        [styles.loaderSpinner]: true,
        [styles.loaderSpinner_small]: size === 'small',
    });

    return (
        <div className={styles.loaderShade}>
            <div className={loaderClass} />
        </div>
    );
};

Loader.defaultProps = defaultProps;
